export const BRAND = {
  empresa: "NILLO EQUIPAMENTOS",
  slogan: "TECNOLOGIA EM ALINHAMENTO DE CHASSIS",
  telefone: "(21) 96469-9478",
  atendimento: "EM TODO BRASIL",
  atividade: "FABRICAÇÃO E COMERCIALIZAÇÃO DE EQUIPAMENTOS PARA ALINHAMENTO DE CHASSIS",
  atendimentoRodape: "SOMENTE WHATSAPP",
  frase: "PRECISÃO • RESISTÊNCIA • TECNOLOGIA • SEU CHASSIS NO ALINHAMENTO CERTO",
};

export const COLORS = {
  bg: "#050B10",
  yellow: "#FFD500",
  white: "#FFFFFF",
  ref: "#0055A5",
  refLight: "#3B8FE0",
  dev: "#FF0000",
  measure: "#10B981",
  amber: "#F59E0B",
};

export const VEHICLE_TYPES = [
  "Caminhão 4x2", "Caminhão 6x2", "Caminhão 6x4", "Caminhão 8x2", "Caminhão 8x4", "Cavalo mecânico",
  "Carreta", "Semirreboque", "Basculante", "Bitrem", "Rodotrem", "Ônibus", "Pick-up", "Van", "Utilitário", "Outro",
];

export const VISUAL_ITEMS = [
  "Empenamento longitudinal", "Empenamento transversal", "Torção do chassi", "Deslocamento lateral",
  "Deslocamento diagonal", "Assimetria entre longarinas", "Longarinas fora de paralelismo", "Travessas deslocadas",
  "Travessas deformadas", "Suportes deslocados", "Pontos de fixação deformados", "Região de suspensão desalinhada",
  "Região de eixo desalinhada", "Danos provocados por colisão", "Danos provocados por excesso de carga",
  "Danos provocados por tombamento", "Danos provocados por acidente", "Sinais de reparo anterior", "Trincas",
  "Amassamentos", "Outras anomalias",
];

export const ANOMALY_TYPES = [
  "Desalinhamento lateral", "Desalinhamento longitudinal", "Empenamento", "Torção", "Deslocamento de eixo",
  "Deslocamento de travessa", "Diferença diagonal", "Assimetria estrutural", "Longarinas não paralelas",
  "Ponto de fixação deslocado", "Deformação por impacto", "Deformação por excesso de carga", "Outra",
];

export const GRAVIDADES = ["LEVE", "MODERADA", "SIGNIFICATIVA", "CRÍTICA"];

export const CLASSIFICACOES = [
  "APROVADO", "APROVADO COM OBSERVAÇÕES", "NECESSITA CORREÇÃO", "REPROVADO PARA OS PARÂMETROS INFORMADOS",
];

export const TOL_SOURCES = [
  "Especificação do fabricante", "Norma técnica", "Parâmetro do responsável técnico", "Outro",
];

export const LADOS = [
  { value: "E", label: "Esquerdo" },
  { value: "D", label: "Direito" },
  { value: "C", label: "Centro" },
];

export const STEPS = [
  { n: 1, key: "veiculo", title: "Identificação do veículo" },
  { n: 2, key: "referencia", title: "Pontos de referência" },
  { n: 3, key: "medicoes", title: "Medições do chassi" },
  { n: 4, key: "mapa", title: "Mapa de desalinhamento" },
  { n: 5, key: "anomalias", title: "Marcação das anomalias" },
  { n: 6, key: "fotos", title: "Registro fotográfico" },
  { n: 7, key: "analise", title: "Análise dos resultados" },
  { n: 8, key: "laudo", title: "Laudo técnico" },
  { n: 9, key: "assinatura", title: "Assinatura e exportação" },
];

export const GRAV_STYLE = {
  LEVE: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10",
  MODERADA: "text-yellow-300 border-yellow-400/40 bg-yellow-400/10",
  SIGNIFICATIVA: "text-orange-400 border-orange-500/40 bg-orange-500/10",
  "CRÍTICA": "text-red-500 border-red-500/50 bg-red-500/10",
};

export const CLASS_STYLE = {
  APROVADO: { cls: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10", rgb: [16, 185, 129] },
  "APROVADO COM OBSERVAÇÕES": { cls: "text-amber-400 border-amber-500/40 bg-amber-500/10", rgb: [245, 158, 11] },
  "NECESSITA CORREÇÃO": { cls: "text-orange-400 border-orange-500/40 bg-orange-500/10", rgb: [249, 115, 22] },
  "REPROVADO PARA OS PARÂMETROS INFORMADOS": { cls: "text-red-500 border-red-500/50 bg-red-500/10", rgb: [255, 0, 0] },
};
